/* eslint-disable */
import React, {useContext} from 'react';
import {Error} from './Error';
import {AppContext} from '@thd-nucleus/app-render';
import {useLocation, useParams} from '@thd-olt-component-react/router';
import {QueryProvider, useDataModel} from '@thd-nucleus/data-sources';
import {useHelmet} from '@thd-nucleus/thd-helmet';
import {extend} from '@thd-nucleus/data-sources';
import {giftCardDataModel} from '../contentful/ExperienceDataModel';
import {GiftCardLayout} from '../contentful/components/giftCardComponents/GiftCardLayout';
import {imagePreloader} from '../contentful/utils/utils';
import '../styles/app.scss';
import {HybridLayout} from "../contentful/components/hybridComponents/HybridLayout";

export const LayoutMapper = ({
                               pageId,
                               customerType,
                               pathWithQueryParams,
                               previewLink,
                               slug
                             }) => {

  const {data, loading, error} = useDataModel('layouts', {
    variables: {
      slug: pageId,
      customerType
    },
  });

  useHelmet('speciality-content', {data}, imagePreloader, [data]);

  const path = `/c/${slug}`;

  if (!data || loading || error) {
    return null;
  }

  const customProps = {
    data,
    loading,
    path,
    customerType,
    pageId,
    pathWithQueryParams,
    previewLink,
    slug
  };
  const layoutTypeID = data?.layouts?.content?.__typename;
  const getLayout = () => {
    switch (layoutTypeID) {
      case "GiftCardLayout":
        return <div style={{backgroundColor: '#FFFFFF'}}>
          <GiftCardLayout {...customProps} />
        </div>;
      case "HybridPLPLayout":
        return <HybridLayout {...customProps} />;
      default:
        return <Error/>;
    }
  };

  return (
    <QueryProvider cacheKey={layoutTypeID}>
      {getLayout()}
    </QueryProvider>
  );
};

LayoutMapper.propTypes = {};

LayoutMapper.displayName = 'LayoutMapperPage';

LayoutMapper.dataModel = extend(giftCardDataModel)
